import { ICategoryCombo } from "../../model/respone/category/ICategoryCombo"
import { apiClient } from "../apiClient"

export const CATEGORY_COMBO_API_RESOURCE = "category-combo"
export const categoryComboApi = {
    SelectAll: () => apiClient.get(`${CATEGORY_COMBO_API_RESOURCE}`),
    Insert: (payload: ICategoryCombo) => apiClient.post(`${CATEGORY_COMBO_API_RESOURCE}`,payload),
    Update: (payload: ICategoryCombo) => apiClient.put(`${CATEGORY_COMBO_API_RESOURCE}`,payload),
    Delete: (id: number) => apiClient.delete(`${CATEGORY_COMBO_API_RESOURCE}/${id}`),
}

